// extracted by mini-css-extract-plugin
export default {"shop__buttons":"Shop_shop__buttons__nW8Z-"};